import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function MyTooltip(props) {
	return (
		<OverlayTrigger
			placement={"top"}
			overlay={<Tooltip id={"tooltip-top"}>{props.label}</Tooltip>}
		>
			{props.children}
		</OverlayTrigger>
	);
}

export default MyTooltip;
